export const toSelectOption = (data) => {
  if (!data || data === 'Error') return data;

  return data.map(({ id, name }) => ({
    key: id,
    value: id,
    content: name,
    search: name,
  }));
};
